module.exports = __webpack_public_path__ + "cc928226495331da1a1cf1eec68d9629.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000Q49.png
// module id = 1452
// module chunks = 0